<template>
  <CBox :bg="['#F1F2F4', 'var(--colors-light-primary-light-gray)']" minHeight="100vh" width="100vw" position="sticky">
    <OmtLayoutContainer bg="#F1F2F4">
      <OmtRow
        v-if="showLocationCard"
        bg="#FFFF"
        :mt="['-24px', '-40px']"
        :mx="['-16px', '-40px']"
        p="16px"
        border-bottom-left-radius="8px"
        border-bottom-right-radius="8px"
      >
        <LocationCard
          :title="locationTitle"
          :subtitle="locationSubtitle"
          @click="onLocationClick"
          :disabled="false"
          :isLocationDisabled="isCurrentLocationDisabled"
          data-tour="busca-rede-location"
        />
      </OmtRow>

      <OmtRow :mx="['-16px', '-40px']" px="16px">
        <CBox w="100%" display="flex" alignItems="center" mb="24px" pb="4px" pt="16px" grid-column-gap="8px">
          <CBox position="relative" flex-shrink="0">
            <OmtButton
              size="xs"
              :variant="hasFilters ? 'solid' : 'outline'"
              rightIcon="angle-down"
              iconMarginRight="0"
              iconMarginLeft="8px"
              :iconColor="hasFilters ? 'var(--colors-light-primary-navy-blue)' : 'var(--colors-light-primary-gray1)'"
              iconSize="sm"
              :border="
                hasFilters
                  ? '1px solid var(--colors-light-primary-navy-blue)'
                  : '.5px solid var(--colors-light-secondary-divider)'
              "
              @click="showFilterModal = true"
              w="auto !important"
              px="8px"
              :bg="hasFilters ? '#EBF0FE' : 'white'"
              data-tour="busca-rede-filtrar"
            >
              <OmtTypography
                as="p1"
                :color="hasFilters ? 'var(--colors-light-primary-navy-blue)' : 'var(--colors-light-primary-gray1)'"
              >
                Filtrar
              </OmtTypography>
            </OmtButton>
            <CBox
              v-show="filtersCount"
              position="absolute"
              top="-8px"
              right="0"
              bg="white"
              border="1px solid var(--colors-light-primary-navy-blue)"
              border-radius="12px"
              min-h="16px"
              min-w="16px"
              h="16px"
              w="16px"
              display="flex"
              justify-content="center"
              align-items="center"
              z-index="1"
            >
              <OmtTypography as="p2" color="var(--colors-light-primary-navy-blue)" font-weight="bold">
                {{ filtersCount }}
              </OmtTypography>
            </CBox>
          </CBox>

          <CBox position="relative" flex-shrink="0" v-if="filtroTelemedicina">
            <OmtButton
              size="xs"
              :variant="isTelemedicinaActive ? 'solid' : 'outline'"
              iconMarginRight="0"
              iconMarginLeft="0"
              iconSize="sm"
              :border="
                isTelemedicinaActive
                  ? '1px solid var(--colors-light-primary-navy-blue)'
                  : '.5px solid var(--colors-light-secondary-divider)'
              "
              @click="toggleTelemedicina"
              w="auto !important"
              px="8px"
              :bg="isTelemedicinaActive ? '#EBF0FE' : 'white'"
            >
              <OmtTypography
                as="p1"
                :color="
                  isTelemedicinaActive ? 'var(--colors-light-primary-navy-blue)' : 'var(--colors-light-primary-gray1)'
                "
              >
                Telemedicina
              </OmtTypography>
            </OmtButton>
          </CBox>

          <OmtInput
            variant="outline"
            borderRadius="8px"
            placeholder="Filtre o resultado por nome"
            icon-left="search"
            :icon-right="textSearch.length > 0 ? 'times' : ''"
            :iconRightClick="textSearch.length > 0 ? clearSearch : null"
            v-model="textSearch"
            :borderColor="searchInputBorderColor"
            :_focus="{ borderColor: searchInputBorderColor, boxShadow: 'initial' }"
            @focus="isSearchInputFocused = true"
            @blur="isSearchInputFocused = false"
            flex="1"
            data-tour="busca-rede-nome-search"
          />
        </CBox>
      </OmtRow>

      <OmtRow :mx="['-16px', '-40px']" px="16px">
        <CFlex w="100%" justify-content="space-between">
          <OmtTypography as="h3-bold">
            Resultados ({{ totalResultados }})<template v-if="exibindoComFiltro">
              · {{ doctorsToRender.length }} com filtros</template
            >
          </OmtTypography>
          <CFlex @click="showSortModal = true" v-if="ordenacoesDisponiveis.length > 0" flexDirection="row">
            <OmtTypography as="p1"> <omt-bold>Ordenar por:</omt-bold>&nbsp;{{ sortLabel }}</OmtTypography>
            <OmtIcons name="angle-down" ml="4px" size="sm" />
          </CFlex>
        </CFlex>
      </OmtRow>

      <OmtRow mb="16px" :mx="['-16px', '-40px']" px="16px">
        <CBox
          v-if="doctorsToRender.length === 0"
          mt="32px"
          mb="32px"
          w="100%"
          textAlign="center"
        >
          <OmtTypography as="p1" color="var(--colors-light-primary-gray1)">
            Nenhum prestador foi encontrado para os critérios informados.
          </OmtTypography>
        </CBox>
      </OmtRow>

      <OmtRow v-for="(item, index) in doctorsToRender" :key="index" :mx="['-16px', '-40px']" px="16px">
        <DoctorsListItem
          variant="primary"
          :isAccreditedNetworkFlow="true"
          @click="onClick(item)"
          :TipoLogradouro="item.TipoLogradouro"
          :EnderecoRua="item.EnderecoRua"
          :EnderecoNumero="item.EnderecoNumero"
          :EnderecoComplemento="item.EnderecoComplemento"
          :EnderecoBairro="item.EnderecoBairro"
          :CodigoEstado="item.CodigoEstado"
          :EnderecoCidade="item.EnderecoCidade"
          :DescricaoPrestador="item.DescricaoPrestador"
          :DescricaoEspecialidade="item.DescricaoEspecialidade"
          :Distancia="item.Distancia"
          :Network="item.NetworkName"
          :DescricaoObservacao="item.DescricaoObservacao"
          :Favorito="item.Favorito"
          :CodigoPrestador="item.CodigoPrestador"
          :SrEndereco="item.SrEndereco"
          :DsIdioma="item.DsIdioma"
          :Nota="item.ScoreTotal"
          :WhatsApp="item.WhatsApp"
          :Teleconsulta="item.Teleconsulta"
          :Agendamento="item.Agendamento"
        />
      </OmtRow>
    </OmtLayoutContainer>

    <FilterModal
      v-if="showFilterModal"
      @close="showFilterModal = false"
      @save="onFilterSave"
      :filters="filters"
      :facilities="facilities"
      :languages="languages"
      :networks="networks"
      :subspecialties="mappedSubspecialties"
    />
    <SortModal
      v-if="showSortModal"
      @close="showSortModal = false"
      @save="onSortSave"
      :sort="sort"
      :ordenacoes-disponiveis="ordenacoesDisponiveis"
    />

    <FilterModal
      v-if="showSubspecialtyFilterModal"
      @close="showSubspecialtyFilterModal = false"
      @save="onFilterSave"
      :filters="filters"
      :subspecialties="mappedSubspecialties"
      title="Subespecialidade"
      :hiddenSubTitle="true"
      buttonLabel="Continuar"
      tour-target="busca-rede-subespecialidade"
    />

    <ModalSearchAddress :is-open="showLocationModal" @close="closeLocationModal" @select="handleAddressSelection" />

    <ModalSearchOtherAddress
      :is-open="showOtherAddressModal"
      @close="closeOtherAddressModal"
      @apply="handleOtherAddressSelection"
    />
  </CBox>
</template>

<script>
import DoctorsListItem from "@/components/Organisms/AffiliateSearch/DoctorsListItem.vue";
import FilterModal from "@/components/Organisms/AffiliateSearch/FilterModal.vue";
import LocationCard from "@/components/Organisms/AffiliateSearch/LocationCard";
import ModalSearchAddress from "@/components/Organisms/AffiliateSearch/ModalSearchAddress";
import ModalSearchOtherAddress from "@/components/Organisms/AffiliateSearch/ModalSearchOtherAddress";
import SortModal from "@/components/Organisms/AffiliateSearch/SortModal.vue";
import {
  countActiveFilters,
  filterAffiliateList,
  getFacilities,
  getLanguages,
  getNetworkList,
  getSubspecialtyList,
  normalizeAffiliateText,
  withNetworkName
} from "@/utils/accreditedListFilters";
import { maybeResumeBuscaRedeTourOnDoctorsList, isBuscaRedeTourMockMode } from "@/utils/buscaRedeTour";
import { debounce } from "lodash";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { mapActions, mapMutations, mapState } from "vuex";

const DEFAULT_SORT = "rede-distancia";
const SORT_OPTIONS = [
  { Codigo: DEFAULT_SORT, Titulo: "Rede e distância" },
  { Codigo: "distancia", Titulo: "Distância" }
];

export default {
  name: "DoctorsList",
  components: {
    FilterModal,
    SortModal,
    DoctorsListItem,
    LocationCard,
    ModalSearchAddress,
    ModalSearchOtherAddress
  },
  async mounted() {
    const hasTermo = !!this.resultadosBusca?.Data?.FiltrosAplicados?.Termo || this.locationType === "Busca por texto";
    const isTourMock = isBuscaRedeTourMockMode();

    if (this.cameFromFavorites || hasTermo || isTourMock) {
      this.$root.$emit("change-back-route", "/redecredenciada-home");
    } else if (this.codigoSubEspecialidade) {
      this.$root.$emit("change-back-route", "/redecredenciada/subespecialidades");
    } else if (this.codigoEspecialidade) {
      this.$root.$emit("change-back-route", "/redecredenciada/especialidades");
    }

    if (isTourMock) {
      this.updateLocalLists();
      this.$root.$emit("change-title-label", this.group ? this.capitalizeWords(this.group) : "Médicos e clínicas");
      this.showSubspecialtyFilterModal = true;
      this.$nextTick(() => {
        maybeResumeBuscaRedeTourOnDoctorsList(this);
      });
      return;
    }

    if (this.cameFromFavorites) {
      this.originalList = this.favoritesList;
      this.setFilterOptions();
      this.filterList();
      this.$root.$emit("change-title-label", this.group ? this.capitalizeWords(this.group) : "Busca de rede");
      this.$nextTick(() => {
        maybeResumeBuscaRedeTourOnDoctorsList(this);
      });
      return;
    }

    if (!this.rede && !this.tipoAtendimento && !this.codigoEspecialidade && !hasTermo) {
      this.$router.replace("/redecredenciada-home");
      return;
    }

    try {
      await this.$root.$emit("show-loading");
      this.SET_MATCH({ CodigoPrestador: null });

      if (
        this.$route.params.fetchResults ||
        !this.resultadosBusca ||
        this.resultadosBusca?.Data?.Prestadores?.length === 0
      ) {
        this.SET_PAGINACAO({ pagina: 1, tamanhoPagina: 10000 });

        await this.searchProviders({
          termo: this.termo || null
        });
      }
      if (this.mappedSubspecialties.length > 0 && !this.cameFromDoctorInfo) {
        this.showSubspecialtyFilterModal = true;
      }
    } catch (e) {
      await this.$root.$emit("hide-loading");
      await Swal.fire({
        text: e.message ? e.message : "Nenhum resultado encontrato",
        confirmButtonText: "OK",
        icon: "warning"
      });
      await this.$router.replace({ name: "affiliate" });
      await this.$root.$emit("show-loading");
      if (this.hasSubspecialties) {
        this.showSubspecialtyFilterModal = true;
      }
    } finally {
      this.updateLocalLists();

      // Se houver uma ordenação vinda da API, atualiza o state de sort
      const ordenacaoAplicada = this.resultadosBusca?.Data?.Ordenacao;
      if (ordenacaoAplicada && ordenacaoAplicada !== this.sort) {
        this.SET_SORT(ordenacaoAplicada);
      } else if (this.ordenacoesDisponiveis.length > 0) {
        const selectedSort = this.ordenacoesDisponiveis.find(o => o.Selecionado);
        if (selectedSort && selectedSort.Codigo !== this.sort) {
          this.SET_SORT(selectedSort.Codigo);
        }
      }
      await this.$root.$emit("hide-loading");

      // Abre o modal se houver subespecialidades disponíveis
      if (this.mappedSubspecialties.length > 0 && !this.cameFromDoctorInfo) {
        this.$nextTick(() => {
          this.showSubspecialtyFilterModal = true;
        });
      }
    }
    this.$root.$emit("change-title-label", this.group ? this.capitalizeWords(this.group) : "Busca de rede");

    // Após o carregamento, se não tiver endereçoSelecionado e a localização estiver desabilitada,

    if (this.locationDisabled) {
      const hasCurrentAsSelected =
        this.enderecoSelecionado &&
        (this.enderecoSelecionado.Tipo === "atual" || this.enderecoSelecionado.Tipo === "Atual");

      if (hasCurrentAsSelected) {
        const addresses = this.$store.state.affiliate.addresses || [];
        const savedAddresses = addresses.filter(endereco => endereco.Tipo !== "atual");
        const fallbackAddress = savedAddresses.find(addr => addr.Tipo !== "outra-cidade") || savedAddresses[0];

        if (fallbackAddress) {
          this.SET_ENDERECO_SELECIONADO(fallbackAddress);
        }
      }
    }

    this.$nextTick(() => {
      maybeResumeBuscaRedeTourOnDoctorsList(this);
    });
  },
  data() {
    return {
      isShowingFavoritos: false,
      isSearchInputFocused: false,
      prevRoute: "/redecredenciada/especialidades", // Ajustado para refletir o novo fluxo sem locs
      textSearch: "",
      originalList: [],
      list: [],
      showFilterModal: false,
      showSortModal: false,
      showLocationModal: false,
      showOtherAddressModal: false,
      facilities: [],
      languages: [],
      networks: [],
      subspecialties: [],
      showSubspecialtyFilterModal: false
    };
  },
  beforeRouteEnter(_, from, next) {
    next(vm => {
      vm.prevRoute = from.path;
    });
  },
  computed: {
    ...mapState("saude", ["hydrated"]),
    ...mapState("affiliate", [
      "deactivated",
      "group",
      "rede",
      "tipoAtendimento",
      "codigoEspecialidade",
      "descricaoEspecialidade",
      "descricaoSubEspecialidade",
      "matches",
      "homeFavoritos",
      "locationType",
      "favorites",
      "latestViews",
      "filters",
      "sort",
      "resultadosBusca",
      "enderecoSelecionado",
      "locationDisabled",
      "termo"
    ]),
    searchInputBorderColor() {
      return this.isSearchInputFocused
        ? "var(--colors-light-primary-navy-blue)"
        : "var(--colors-light-secondary-divider)";
    },
    cameFromFavorites() {
      const param = this.$route?.params?.isFavoritos;
      return param === true || param === "true" || this.locationType === "Favoritos";
    },
    cameFromDoctorInfo() {
      return this.prevRoute && this.prevRoute.includes("/medico/");
    },
    favoritesList() {
      const favoritos =
        Array.isArray(this.homeFavoritos) && this.homeFavoritos.length > 0 ? this.homeFavoritos : this.favorites;
      return (Array.isArray(favoritos) ? favoritos : []).map(withNetworkName);
    },
    doctorsToRender() {
      return this.list;
    },
    // Total que a busca retornou. Vem do adaptador (TotalBusca).
    totalResultados() {
      if (this.cameFromFavorites) return (this.originalList || []).length;
      const d = this.resultadosBusca?.Data;
      return (d?.TotalBusca ?? d?.Total ?? this.doctorsToRender.length) || 0;
    },
    // Há filtro client-side reduzindo a lista?
    exibindoComFiltro() {
      const d = this.resultadosBusca?.Data;
      const filtroServidor = !!(
        d &&
        typeof d.TotalBusca === "number" &&
        typeof d.Total === "number" &&
        d.TotalBusca !== d.Total
      );
      const filtroTexto = !!(this.textSearch || "").trim();
      const base = this.cameFromFavorites ? this.originalList || [] : this.matches || [];
      const filtroTela = base.length > 0 && this.doctorsToRender.length !== base.length;
      return filtroServidor || filtroTexto || filtroTela;
    },
    ordenacoesDisponiveis() {
      const currentSort = this.sort || DEFAULT_SORT;
      return SORT_OPTIONS.map(option => ({
        ...option,
        Selecionado: option.Codigo === currentSort
      }));
    },
    filtrosDisponiveis() {
      return this.resultadosBusca?.Data?.FiltrosDisponiveis || [];
    },
    filtroTelemedicina() {
      return this.filtrosDisponiveis.find(filtro => filtro.Codigo === "telemedicina") || null;
    },
    availableLanguagesFromApi() {
      const idiomaFilter = this.filtrosDisponiveis.find(filtro => filtro.Codigo === "idioma");
      if (!idiomaFilter?.Opcoes?.length) return [];

      return idiomaFilter.Opcoes.map(opcao => {
        const label = opcao.Titulo || opcao.Codigo;
        return {
          label,
          normalizedLabel: normalizeAffiliateText(label).trim()
        };
      });
    },
    isTelemedicinaActive() {
      if (typeof this.filters?.telemedicina === "boolean") return this.filters.telemedicina;
      return !!this.resultadosBusca?.Data?.FiltrosAplicados?.Telemedicina;
    },
    subespecialidadeFilterFromApi() {
      return this.filtrosDisponiveis.find(filtro => filtro.Codigo === "subespecialidade") || null;
    },
    mappedSubspecialties() {
      const opcoes = this.subespecialidadeFilterFromApi?.Opcoes || [];
      if (opcoes.length === 0) return [];

      const activeSubspecialties = this.filters?.subspecialties || [];
      const codigosAplicados = this.resultadosBusca?.Data?.FiltrosAplicados?.CodigoSubEspecialidade
        ? this.resultadosBusca.Data.FiltrosAplicados.CodigoSubEspecialidade.split(",")
        : [];

      const mappedOptions = [];

      opcoes.forEach(opcao => {
        const label = opcao.Titulo || "";
        const valor = opcao.Codigo;
        const normalizedLabel = normalizeAffiliateText(label).trim();
        if (!normalizedLabel) return;

        const isActive =
          activeSubspecialties.some(sub => sub.normalizedLabel === normalizedLabel) ||
          codigosAplicados.includes(valor) ||
          !!opcao.Selecionado;

        const existingOption = mappedOptions.find(option => option.normalizedLabel === normalizedLabel);
        if (existingOption) {
          existingOption.isActive = existingOption.isActive || isActive;
          return;
        }

        mappedOptions.push({
          label,
          normalizedLabel,
          isActive
        });
      });

      return mappedOptions;
    },
    sortLabel() {
      const selectedSort = this.ordenacoesDisponiveis.find(o => o.Codigo === this.sort);
      return selectedSort ? selectedSort.Titulo : "Rede e distância";
    },
    hasFilters() {
      return this.filtersCount > 0;
    },
    filtersCount() {
      return countActiveFilters(this.filters);
    },

    hasSubspecialties() {
      return Array.isArray(this.subspecialties) && this.subspecialties.length > 0;
    },
    locationTitle() {
      if (this.enderecoSelecionado) {
        if (
          (this.enderecoSelecionado.Tipo === "atual" || this.enderecoSelecionado.Tipo === "Atual") &&
          this.enderecoSelecionado.Titulo
        ) {
          return this.enderecoSelecionado.Titulo;
        }
        return this.enderecoSelecionado.Titulo || "Localização";
      }
      return "Localização";
    },
    locationSubtitle() {
      if (this.enderecoSelecionado) {
        if (this.enderecoSelecionado.Tipo === "atual" || this.enderecoSelecionado.Tipo === "Atual") {
          return "Buscando pela sua localização atual";
        }
        return this.enderecoSelecionado.Descricao || this.formatLocationSubtitle(this.enderecoSelecionado);
      }
      return "";
    },
    isCurrentLocationDisabled() {
      if (!this.locationDisabled) return false;

      const isEnderecoAtual =
        this.enderecoSelecionado &&
        (this.enderecoSelecionado.Tipo === "atual" || this.enderecoSelecionado.Tipo === "Atual");

      return !!isEnderecoAtual;
    },
    showLocationCard() {
      const isTextSearch =
        this.locationType === "Busca por texto" || !!this.resultadosBusca?.Data?.FiltrosAplicados?.Termo;

      return !!this.enderecoSelecionado && !this.cameFromFavorites && !isTextSearch;
    }
  },
  watch: {
    textSearch: {
      handler: debounce(function () {
        this.filterList();
      }, 300)
    }
  },
  methods: {
    ...mapActions("affiliate", ["searchProviders"]),
    ...mapMutations("affiliate", ["SET_MATCH", "SET_FILTERS", "SET_SORT", "SET_ENDERECO_SELECIONADO", "SET_PAGINACAO"]),
    updateLocalLists() {
      switch (this.locationType) {
        case "Favoritos":
          this.originalList = this.favorites;
          break;
        case "Últimas visualizações":
          this.originalList = this.latestViews;
          break;
        default:
          this.originalList = this.matches;
      }
      this.originalList = this.originalList.map(withNetworkName);
      this.setFilterOptions();
      this.filterList();
    },
    normalize(value) {
      return value.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    },
    formatLocationSubtitle(location) {
      if (location.Descricao) return location.Descricao;
      if (location.Endereco) return location.Endereco;
      const cityState = [location.Cidade, location.Uf].filter(Boolean).join("/");
      return [cityState, location.Cep].filter(Boolean).join(" - ");
    },
    async onClick(match) {
      await this.$root.$emit("show-loading");
      await this.SET_MATCH(match);
      const rede = this.rede ? this.rede : "0000";

      try {
        await this.$router.push({
          name: "affiliate.docInfo",
          params: {
            situacao: this.deactivated ? "I" : "A",
            rede,
            cdPrestador: match.CodigoPrestador,
            srEndereco: match.SrEndereco
          }
        });
      } catch (err) {
        console.error("Erro na navegação do router:", err);
      } finally {
        await this.$root.$emit("hide-loading");
      }
    },
    filterList() {
      const clientFilters = { ...(this.filters || {}) };
      if (typeof clientFilters.telemedicina !== "boolean") {
        clientFilters.telemedicina = this.isTelemedicinaActive;
      }

      this.list = filterAffiliateList(this.originalList, clientFilters, this.textSearch.trim());
    },
    onFilterSave(filters) {
      this.SET_FILTERS({ ...filters, telemedicina: this.isTelemedicinaActive });
      this.filterList();
    },
    searchByProviderName() {
      // Campo de texto da tela de resultados: apenas filtra a lista já carregada (client-side).
      this.filterList();
    },
    async onSortSave(sortCode) {
      if (this.sort === sortCode) return;
      // Ordenação = client-side (a lista já vem ordenada da API); só atualiza o estado e re-filtra.
      this.SET_SORT(sortCode);

      try {
        await this.$root.$emit("show-loading");
        this.SET_PAGINACAO({ pagina: 1, tamanhoPagina: 10000 });

        let usarLocalizacaoAtual = false;
        switch (this.locationType) {
          case "Perto da minha casa":
          case "Perto do meu trabalho":
          case "Atual":
            usarLocalizacaoAtual = true;
            break;
          default:
            usarLocalizacaoAtual = false;
        }

        await this.searchProviders({
          usarLocalizacaoAtual,
          ordenacao: sortCode,
          termo: this.termo || null
        });

        this.updateLocalLists();

      } catch (e) {
        console.error("Erro ao ordenar:", e);
      } finally {
        await this.$root.$emit("hide-loading");
      }
    },
    capitalizeWords(inputString) {
      return inputString.charAt(0).toUpperCase() + inputString.slice(1).toLowerCase();
    },
    cleanSortsAndFilters() {
      this.SET_FILTERS({ telemedicina: false });
      this.filterList();
      const defaultSort = this.ordenacoesDisponiveis.length > 0 ? this.ordenacoesDisponiveis[0].Codigo : DEFAULT_SORT;
      this.onSortSave(defaultSort);
    },
    toggleTelemedicina() {
      this.SET_FILTERS({ ...(this.filters || {}), telemedicina: !this.isTelemedicinaActive });
      this.filterList();
    },
    onLocationClick() {
      this.showLocationModal = true;
    },
    clearSearch() {
      this.textSearch = "";
    },
    closeLocationModal() {
      this.showLocationModal = false;
    },
    openOtherAddressModal() {
      this.showOtherAddressModal = true;
    },
    closeOtherAddressModal() {
      this.showOtherAddressModal = false;
    },
    async handleAddressSelection(payload) {
      if (payload?.type === "outra-cidade") {
        await this.$root.$emit("show-loading");
        try {
          await this.$store.dispatch("affiliate/fetchStatesNetwork");
          this.closeLocationModal();
          this.openOtherAddressModal();
        } finally {
          await this.$root.$emit("hide-loading");
        }
        return;
      }

      // Armazena o endereço selecionado na store
      this.SET_ENDERECO_SELECIONADO(payload?.data || null);

      this.closeLocationModal();
      this.$root.$emit("show-loading");
      this.SET_PAGINACAO({ pagina: 1, tamanhoPagina: 10000 });

      // Dispara uma nova busca com base no novo endereço.
      // Se type === "atual", definimos usarLocalizacaoAtual = true, senão = false
      const usarLocalizacaoAtual = payload?.type === "atual";
      this.searchProviders({
        usarLocalizacaoAtual,
        codigoSubEspecialidade: "",
        termo: this.termo || null
      })
        .then(() => this.onAddressChanged())
        .finally(() => {
          this.$root.$emit("hide-loading");
        });
    },
    handleOtherAddressSelection(payload) {
      if (payload?.type === "outra-cidade-selecionada") {
        this.SET_ENDERECO_SELECIONADO({
          ...payload.data,
          Tipo: "outra-cidade-selecionada"
        });

        // Dispara a busca quando seleciona uma nova cidade/estado
        this.$root.$emit("show-loading");
        this.SET_PAGINACAO({ pagina: 1, tamanhoPagina: 10000 });
        this.searchProviders({
          usarLocalizacaoAtual: false,
          codigoSubEspecialidade: "",
          termo: this.termo || null
        })
          .then(() => this.onAddressChanged())
          .finally(() => {
            this.$root.$emit("hide-loading");
          });
      }
    },
    onAddressChanged() {
      this.SET_FILTERS({});
      this.updateLocalLists();

      if (this.mappedSubspecialties.length > 0) {
        this.$nextTick(() => {
          this.showSubspecialtyFilterModal = true;
        });
      }
    },
    setFilterOptions() {
      this.facilities = getFacilities(this.originalList);

      if (this.availableLanguagesFromApi.length > 0) {
        this.originalList.forEach(item => {
          const raw = item.Idiomas ?? (item.DsIdioma ? [item.DsIdioma] : []);
          item.languages = raw.map(value => normalizeAffiliateText(value).trim()).filter(Boolean);
        });
        this.languages = this.availableLanguagesFromApi;
      } else {
        this.languages = getLanguages(this.originalList);
      }

      this.networks = getNetworkList(this.originalList);
      this.subspecialties = getSubspecialtyList(this.originalList);
    }
  }
};
</script>
